import 'slick-carousel';
import 'slick-lightbox';

import './inputs.js';

import AOS from 'aos';
AOS.init( {
    disable: 'mobile',
    once: true,
    duration: 500,
    anchorPlacement: 'top-bottom',
} );

// global
import './global/global.js';
import './global/modal.js';
import './global/header.js';

// wocommerce
// import './woocommerce/product.js';

import './template-parts/icons.js';
import './template-parts/accordion.js';
import './template-parts/single-post.js';
import './template-parts/slider.js';
import './template-parts/filter.js';

// blocks
import './blocks/accordion.js';
// import './blocks/homepage-banner.js';
// import './blocks/latest-blogs-slider.js';
// import './blocks/gallery-slider.js';
// import './blocks/big-slider.js';
// import './blocks/accreditations-slider.js';
// import './blocks/blog-listing.js';
// import './blocks/staggered-content.js';
// import './blocks/features.js';
// import './blocks/accordion-cards-slider.js';
// import './blocks/testimonial-slider.js';
// import './blocks/hero-banner.js';
// import './blocks/case-study-slider.js';
// import './blocks/tabs.js';
// import './blocks/image-and-content-slider.js';
